<div class="lt-filter-row filter-row">
    <!-- Logic Selector (only show for non-first rows) -->
    @if (showLogic()) {
        <mat-form-field appearance="outline" class="logic-form-field">
            <mat-select [formControl]="logicControl" placeholder="Logic">
                <mat-option value="and">AND</mat-option>
                <mat-option value="or">OR</mat-option>
            </mat-select>
        </mat-form-field>
    }

    <form [formGroup]="form" class="filter-form d-flex">
        
        <!-- Field Selector -->
        <mat-form-field appearance="outline" class="filter-form-field-field">
            <mat-label>Field</mat-label>
            <mat-select formControlName="field">
                @for (column of columns(); track column.field) {
                    <mat-option [value]="column.field">{{ column.title }}</mat-option>
                }
            </mat-select>
        </mat-form-field>    

        <!-- Operator Selector -->
        <mat-form-field appearance="outline" class="filter-form-field-operator">
            <mat-label>Operator</mat-label>
            <mat-select formControlName="operator">
                @for (operator of availableOperators(); track operator.operator) {
                    <mat-option [value]="operator.operator">{{ operator.label }}</mat-option>
                }
            </mat-select>
        </mat-form-field>

        <!-- Value Input -->
        @if (selectedOperator()?.requiresValue) {
        <div class="filter-form-field-field">
            @switch (selectedColumn()?.type) {
                @case ('string') {
                    @if (isInOperator()) {
                        <!-- Multi-value input for 'in' operators -->
                        <mat-form-field appearance="outline">
                            <mat-label>Values</mat-label>
                            <mat-chip-grid #chipGrid>
                                @for (chip of valueChips(); track chip) {
                                    <mat-chip-row 
                                        (removed)="removeChip(chip)"
                                        [removable]="true">
                                        {{ chip }}
                                        <mat-icon matChipRemove>cancel</mat-icon>
                                    </mat-chip-row>
                                }
                            </mat-chip-grid>
                            <input matInput #chipInput
                                [matChipInputFor]="chipGrid"
                                (matChipInputTokenEnd)="addChip($event)"
                                placeholder="Type and press Enter">
                        </mat-form-field>
                    } @else {
                        <!-- Single string input -->
                        <mat-form-field appearance="outline">
                            <mat-label>Value</mat-label>
                            <input matInput formControlName="value" type="text">
                        </mat-form-field>
                    }
                }
                @case ('number') {
                    @if (isInOperator()) {
                        <!-- Multi-value number input -->
                        <mat-form-field appearance="outline">
                            <mat-label>Values</mat-label>
                            <mat-chip-grid #numberChipGrid>
                                @for (chip of valueChips(); track chip) {
                                    <mat-chip-row 
                                        (removed)="removeChip(chip)"
                                        [removable]="true">
                                        {{ chip }}
                                        <mat-icon matChipRemove>cancel</mat-icon>
                                    </mat-chip-row>
                                }
                            </mat-chip-grid>
                            <input matInput #numberChipInput
                                [matChipInputFor]="numberChipGrid"
                                (matChipInputTokenEnd)="addNumberChip($event)"
                                type="number"
                                placeholder="Type number and press Enter">
                        </mat-form-field>
                    } @else {
                        <!-- Single number input -->
                        <mat-form-field appearance="outline">
                            <mat-label>Value</mat-label>
                            <input matInput formControlName="value" type="number">
                        </mat-form-field>
                    }
                }
                @case ('date') {
                    <mat-form-field appearance="outline">
                        <mat-label>Date</mat-label>
                        <input matInput [matDatepicker]="picker" formControlName="value">
                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                }
                @case ('boolean') {
                    <mat-checkbox formControlName="value">
                        {{ form.get('value')?.value ? 'True' : 'False' }}
                    </mat-checkbox>
                    <!-- <button matButton="elevated" 
                        [color]="child.operator === 'isTrue' ? 'primary' : undefined"
                        (click)="setBoolean(child, true)">
                        True
                    </button>
                    <button matButton="elevated" 
                        [color]="child.operator === 'isFalse' ? 'primary' : undefined"
                        (click)="setBoolean(child, false)">
                        True
                    </button> -->
                }
                @case ('enum') {
                    @if (isInOperator()) {
                        <!-- Multi-value enum selection -->
                        <mat-form-field appearance="outline">
                            <mat-label>Values</mat-label>
                            <mat-select formControlName="value" multiple>
                            @for (enumValue of selectedColumn()!.enumValues!; track enumValue.key) {
                                <mat-option [value]="enumValue.value">
                                <span [matTooltip]="enumValue.description || ''" 
                                        [matTooltipDisabled]="!enumValue.description">
                                    {{ enumValue.text }}
                                </span>
                                </mat-option>
                            }
                            </mat-select>
                            <mat-hint>
                                @if (form.get('value')?.value && Array.isArray(form.get('value')?.value)) {
                                    {{ getSelectedCount() }} selected
                                }
                            </mat-hint>
                        </mat-form-field>
                        } @else {
                            <!-- Single enum selection -->
                            <mat-form-field appearance="outline">
                                <mat-label>Value</mat-label>
                                <mat-select formControlName="value">
                                    @for (enumValue of selectedColumn()!.enumValues!; track enumValue.key) {
                                        <mat-option [value]="enumValue.value">
                                            <span [matTooltip]="enumValue.description || ''" 
                                                  [matTooltipDisabled]="!enumValue.description">
                                                {{ enumValue.text }}
                                            </span>
                                        </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        }
                }
                @default {
                    @if (selectedColumn()?.values) {
                        <!-- Predefined values dropdown -->
                        <mat-form-field appearance="outline">
                            <mat-label>Value</mat-label>
                            <mat-select formControlName="value">
                                @for (valueOption of selectedColumn()!.values!; track valueOption.value) {
                                    <mat-option [value]="valueOption.value">{{ valueOption.text }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    } @else {
                        <!-- Fallback text input -->
                        <mat-form-field appearance="outline">
                            <mat-label>Value</mat-label>
                            <input matInput formControlName="value" type="text">
                        </mat-form-field>
                    }
                }
            }
        </div>
        }

        <!-- Case sensitivity toggle for string operations -->
        @if (selectedColumn()?.type === 'string' && selectedOperator()?.requiresValue) {
            <mat-checkbox formControlName="ignoreCase" class="ignore-case-margin">
                Ignore Case
            </mat-checkbox>
        }

    </form>

    <!-- Actions -->
    <div class="lt-filter-actions filter-actions">
        <button matIconButton color="warn" (click)="remove.emit()" [attr.aria-label]="'Remove filter'">
            <mat-icon>delete</mat-icon>
        </button>
    </div>
</div>